// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oFOJStf7IgqbknItU5Ie{border-radius:4px;display:inline-block;overflow:hidden}.snaL2Ey2rJkibCndPWcE{text-align:center;padding-top:50px;padding-bottom:150px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `oFOJStf7IgqbknItU5Ie`,
	"wrap": `snaL2Ey2rJkibCndPWcE`
};
export default ___CSS_LOADER_EXPORT___;
